import './src/assets/css/bootstrap.min.css';
import './src/assets/css/animate.min.css';
import './src/assets/css/boxicons.min.css';
import './src/assets/css/flaticon.css';
import 'react-accessible-accordion/dist/fancy-example.css';
// import '../../../../node_modules/aos/dist/aos.css';
import 'aos/dist/aos.css'; // Corrected path for aos.css
// import './i18n';
// gatsby-browser.js

// Global Style
import './src/assets/css/style.css';
import './src/assets/css/responsive.css';
import './src/assets/css/dark.css';

// Keep Gatsby's React 18 hydration behaviour while surfacing the component
// stack for recoverable mismatches during verification.
export const replaceHydrateFunction = () => (element, container) => {
    const reactDomClient = require('react-dom/client');

    if (container && container.children.length) {
        const root = reactDomClient.hydrateRoot(container, element, {
            onRecoverableError(error, errorInfo) {
                console.error('RankingPT hydration mismatch', error.message, errorInfo?.componentStack || '');
            },
        });
        return () => root.unmount();
    }

    const root = reactDomClient.createRoot(container);
    root.render(element);
    return () => root.unmount();
};
// export const onClientEntry = () => {
//     const clarityScript = document.createElement("script");
//     clarityScript.src = "https://www.clarity.ms/tag/okmhvj9kw0";
//     clarityScript.defer = true;
//     document.head.appendChild(clarityScript);

//     const gtagScript = document.createElement("script");
//     gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-9F4FZ6ZXVX";
//     gtagScript.defer = true;
//     document.head.appendChild(gtagScript);
// };
